import { useAxios } from './axiosService';
import { PLAIN_TO_ENUM } from '../common/constants/reportPlans';

export const useVinCodeService = () => {
    const { axios } = useAxios();

    const createReport = (vin, language, idempotencyKey, checkReportReusage, selectedPlan) => {
        const transformedType = PLAIN_TO_ENUM[selectedPlan];
        if (!transformedType) {
            throw new Error(`Unknown report plan: ${selectedPlan}`);
        }

        return axios.post(
            '/jobs/report',
            {
                vin,
                language,
                checkReportReusage,
                type: transformedType,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-idempotency-key': idempotencyKey,
                },
            }
        );
    };

    const getVinCodesByConsumerId = (consumerId, searchString) => {
        return axios.get(`/jobs/reports/${consumerId}${searchString ? `?searchString=${searchString}` : ''}`);
    };

    const changeStatus = (ids, statusId) => {
        return axios.put('/jobs/change-status', { ids, statusId });
    };

    const deleteReport = ids => {
        return axios.delete(`/jobs`, { data: { ids } });
    };

    const decodeVin = vin => {
        return axios.get(`/vin-decoder/${vin}`);
    };

    return {
        createReport,
        getVinCodesByConsumerId,
        changeStatus,
        deleteReport,
        decodeVin,
    };
};
